export function cleanupParams<T extends Record<string, unknown>>(obj: T | undefined | null): { [K in keyof T]: NonNullable<T[K]> } {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result = {} as any;

  if (obj === null || typeof obj === 'undefined') {
    return result;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let target: any = obj;
  if (typeof target !== 'object') {
    target = [target];
  }

  Object.keys(target).forEach((key) => {
    const value = target[key];

    if (value !== null && value !== undefined && value !== '') {
      if (Array.isArray(value)) {
        const cleanArray = value.filter(
          (item) => item !== null && item !== undefined && item !== '',
        );
        if (cleanArray.length > 0) {
          result[key] = cleanArray;
        }
      }
      else {
        result[key] = value;
      }
    }
  });

  return result as { [K in keyof T]: NonNullable<T[K]> };
}

export function ensureArray<T = string>(
  value: string[] | string | undefined,
  mapper: (val: string) => T = (v) => v as T,
): T[] {
  if (value === undefined) {
    return [];
  }

  const rawArray = Array.isArray(value)
    ? value
    : value.includes(',')
      ? value.split(',')
      : [value];

  return rawArray
    .map((val) => val === undefined ? val : mapper(val));
}
